import React from 'react';
import './LegalPage.css';

const TermsPage = () => (
  <div className="legal-page">
    <h1>Terms of Service</h1>
    <p className="legal-updated">Last updated: 17 September 2026</p>

    <h2>1. The Service</h2>
    <p>
      Irish Visa Tracker ("the Service") is an independent monitoring and
      notification service. We are not affiliated with the Government of
      Ireland, the Department of Foreign Affairs, or any Irish embassy.
      We do not process visa applications or make immigration decisions.
    </p>

    <h2>2. Data source</h2>
    <p>
      All status alerts are derived from the daily NDVO decisions file
      published at <a href="https://www.ireland.ie/en/india/newdelhi/services/visas/processing-times-and-decisions/" target="_blank" rel="noopener noreferrer">ireland.ie/en/india/newdelhi</a>.
      We do not invent or estimate decisions.
    </p>

    <h2>3. Use of the Service</h2>
    <ul>
      <li>You must provide accurate reference numbers that you are entitled to monitor.</li>
      <li>You must not use the Service to stalk, harass, or surveil other applicants.</li>
      <li>You must not scrape or resell alerts without written permission.</li>
    </ul>

    <h2>4. Refunds</h2>
    <p>
      Premium is a one-time, non-refundable service purchase. Monitoring setup
      and premium access begin after payment verification, so we do not offer
      change-of-mind or unused-access refunds. This does not limit rights required
      by law or rights under the terms presented for an earlier purchase.
      See our <a href="/refund">Refund Policy</a> for details and billing support.
    </p>

    <h2>5. No warranty</h2>
    <p>
      The Service is provided "as is" without warranty of any kind. While we
      aim for instant delivery, we cannot guarantee that alerts will arrive
      before a decision is otherwise visible on the official NDVO file.
    </p>

    <h2>6. Limitation of liability</h2>
    <p>
      To the maximum extent permitted by law, Irish Visa Tracker is not liable
      for any indirect, incidental, or consequential damages arising from use
      of the Service.
    </p>

    <h2>7. Governing law</h2>
    <p>
      These terms are governed by the laws of India. Any dispute will be
      subject to the exclusive jurisdiction of the courts of Bengaluru, India.
    </p>

    <h2>8. Contact</h2>
    <p>
      Email <a href="mailto:visahelp@irelandvisatracker.in">visahelp@irelandvisatracker.in</a>
      with any questions.
    </p>
  </div>
);

export default TermsPage;
